import axios from 'axios'

// http://www.axios-js.com/zh-cn/
const httpInstance = axios.create({
  timeout: 15000,
  withCredentials: true, // 跨域携带cookie
  crossDomain: true, // 跨域请求
})

export default httpInstance
